import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    AbstractControl,
    UntypedFormArray,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
} from '@angular/forms';
import { FIRST_ELEMENT_INDEX, USER_INPUT_DEBOUNCE_TIME } from '@modeso/aumico-lib-core-fe';
import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime } from 'rxjs/operators';
import { ITranslationsTableData } from '../../interfaces/translations-table-data.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-title-translations',
    templateUrl: './title-translations.component.html',
    styleUrls: ['./title-translations.component.scss'],
})
export class TitleTranslationsComponent implements OnInit {
    public formGroup: UntypedFormGroup | undefined;
    public translationsFormArray: UntypedFormArray | undefined;
    public displayedColumns: string[] = ['name', 'currentLocale', 'selectedLocale'];

    @Input() tableData: IDynamicKeyValue | undefined;
    @Input() currentLocale = 'de-ch';
    @Input() selectedLocale: string | undefined;

    @Output() translationValuesChanged: EventEmitter<ITranslationsTableData> =
        new EventEmitter<ITranslationsTableData>();

    constructor(private readonly formBuilder: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.formBuilder.group({
            translationsFormArray: this.formBuilder.array([]),
        });
        this.translationsFormArray = this.getAllAsFormArray();

        this.monitorFormChanges();

        this.formGroup.setControl('translationsFormArray', this.translationsFormArray);
        this.formGroup.updateValueAndValidity();
    }

    private getAllAsFormArray(): UntypedFormArray {
        const formGroups: AbstractControl[] = this.getTableEntryFormGroup(this.tableData);
        return new UntypedFormArray(formGroups);
    }

    private getTableEntryFormGroup(data: IDynamicKeyValue): AbstractControl[] {
        const dataSourceFormGroups: AbstractControl[] = [];

        const dataSourceFormGroup: { [key: string]: AbstractControl } = {};
        dataSourceFormGroup['name'] = new UntypedFormControl('Title');
        dataSourceFormGroup['currentLocale'] = new UntypedFormControl(data[this.currentLocale]);
        dataSourceFormGroup['selectedLocale'] = new UntypedFormControl(data[this.selectedLocale]);
        dataSourceFormGroups.push(new UntypedFormGroup(dataSourceFormGroup));

        return dataSourceFormGroups;
    }

    private monitorFormChanges(): void {
        if (this.formGroup == null) {
            throw new Error('Form group is undefined.');
        }
        this.formGroup.valueChanges
            .pipe(debounceTime(USER_INPUT_DEBOUNCE_TIME), untilDestroyed(this))
            .subscribe((formValue) => {
                this.translationValuesChanged.emit(formValue.translationsFormArray[FIRST_ELEMENT_INDEX]);
            });
    }
}
